export const NON_REIMBURSABLE_VALUE =
  "Non-reimbursable - You used a company provided credit card that will get paid by your company.";
export const REIMBURSABLE_VALUE =
  "Reimbursable - You paid out of pocket for a valid, non-taxable business expense.";
